function MonitorListCtrl($scope, $state) {
    $scope.type =  $state.current.type;
    $scope.$root.dividedInner = true;
}